import { createGlobalStyle } from 'styled-components';

import mediaQueries from './settings/mediaQueries';
import colors from './settings/colors';
import variables from './settings/variables';

import core from './core/core';
import fonts from './core/fonts';
import typography from './core/typography';

const theme = {
  mediaQueries,
  colors,
  variables,
};

const GlobalStyles = createGlobalStyle`
  ${core}
  ${fonts}
  ${typography}
`;

export { GlobalStyles, theme };
